/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverInviteDtoModel, DriverInviteDtoModelType } from "./DriverInviteDtoModel"
import { DriverInviteDtoModelSelector } from "./DriverInviteDtoModel.base"
import { OrganizationDtoModel, OrganizationDtoModelType } from "./OrganizationDtoModel"
import { OrganizationDtoModelSelector } from "./OrganizationDtoModel.base"
import { PermissionDtoModel, PermissionDtoModelType } from "./PermissionDtoModel"
import { PermissionDtoModelSelector } from "./PermissionDtoModel.base"
import { RoleDtoModel, RoleDtoModelType } from "./RoleDtoModel"
import { RoleDtoModelSelector } from "./RoleDtoModel.base"
import { SsoProviderDtoModel, SsoProviderDtoModelType } from "./SsoProviderDtoModel"
import { SsoProviderDtoModelSelector } from "./SsoProviderDtoModel.base"
import { SupportSessionDtoModel, SupportSessionDtoModelType } from "./SupportSessionDtoModel"
import { SupportSessionDtoModelSelector } from "./SupportSessionDtoModel.base"
import { UserLegacyMetadataDtoModel, UserLegacyMetadataDtoModelType } from "./UserLegacyMetadataDtoModel"
import { UserLegacyMetadataDtoModelSelector } from "./UserLegacyMetadataDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  roles: IObservableArray<RoleDtoModelType>;
  ssoProviders: IObservableArray<SsoProviderDtoModelType>;
  permissions: IObservableArray<PermissionDtoModelType>;
  companies: IObservableArray<DriverInviteDtoModelType>;
  organization: OrganizationDtoModelType;
}

/**
 * UserDtoBase
 * auto generated base class for the model UserDtoModel.
 */
export const UserDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('UserDto')
  .props({
    __typename: types.optional(types.literal("UserDto"), "UserDto"),
    id: types.identifier,
    email: types.union(types.undefined, types.null, types.string),
    phone: types.union(types.undefined, types.null, types.string),
    fullname: types.union(types.undefined, types.null, types.string),
    uuid: types.union(types.undefined, types.string),
    access_token: types.union(types.undefined, types.null, types.string),
    tempPassword: types.union(types.undefined, types.boolean),
    deleted: types.union(types.undefined, types.boolean),
    organizationId: types.union(types.undefined, types.integer),
    verified: types.union(types.undefined, types.boolean),
    projectsCount: types.union(types.undefined, types.integer),
    roles: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => RoleDtoModel)))),
    createdBy: types.union(types.undefined, types.null, types.integer),
    ssoProviders: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => SsoProviderDtoModel)))),
    permissions: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => PermissionDtoModel)))),
    companies: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => DriverInviteDtoModel)))),
    defaultWorkspaceId: types.union(types.undefined, types.null, types.integer),
    organization: types.union(types.undefined, MSTGQLRef(types.late((): any => OrganizationDtoModel))),
    supportSessionUuid: types.union(types.undefined, types.null, types.string),
    activeSupportSession: types.union(types.undefined, types.null, types.late((): any => SupportSessionDtoModel)),
    metadata: types.union(types.undefined, types.null, types.late((): any => UserLegacyMetadataDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class UserDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get email() { return this.__attr(`email`) }
  get phone() { return this.__attr(`phone`) }
  get fullname() { return this.__attr(`fullname`) }
  get uuid() { return this.__attr(`uuid`) }
  get access_token() { return this.__attr(`access_token`) }
  get tempPassword() { return this.__attr(`tempPassword`) }
  get deleted() { return this.__attr(`deleted`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get verified() { return this.__attr(`verified`) }
  get projectsCount() { return this.__attr(`projectsCount`) }
  get createdBy() { return this.__attr(`createdBy`) }
  get defaultWorkspaceId() { return this.__attr(`defaultWorkspaceId`) }
  get supportSessionUuid() { return this.__attr(`supportSessionUuid`) }
  roles(builder: string | RoleDtoModelSelector | ((selector: RoleDtoModelSelector) => RoleDtoModelSelector) | undefined) { return this.__child(`roles`, RoleDtoModelSelector, builder) }
  ssoProviders(builder: string | SsoProviderDtoModelSelector | ((selector: SsoProviderDtoModelSelector) => SsoProviderDtoModelSelector) | undefined) { return this.__child(`ssoProviders`, SsoProviderDtoModelSelector, builder) }
  permissions(builder: string | PermissionDtoModelSelector | ((selector: PermissionDtoModelSelector) => PermissionDtoModelSelector) | undefined) { return this.__child(`permissions`, PermissionDtoModelSelector, builder) }
  companies(builder: string | DriverInviteDtoModelSelector | ((selector: DriverInviteDtoModelSelector) => DriverInviteDtoModelSelector) | undefined) { return this.__child(`companies`, DriverInviteDtoModelSelector, builder) }
  organization(builder: string | OrganizationDtoModelSelector | ((selector: OrganizationDtoModelSelector) => OrganizationDtoModelSelector) | undefined) { return this.__child(`organization`, OrganizationDtoModelSelector, builder) }
  activeSupportSession(builder: string | SupportSessionDtoModelSelector | ((selector: SupportSessionDtoModelSelector) => SupportSessionDtoModelSelector) | undefined) { return this.__child(`activeSupportSession`, SupportSessionDtoModelSelector, builder) }
  metadata(builder: string | UserLegacyMetadataDtoModelSelector | ((selector: UserLegacyMetadataDtoModelSelector) => UserLegacyMetadataDtoModelSelector) | undefined) { return this.__child(`metadata`, UserLegacyMetadataDtoModelSelector, builder) }
}
export function selectFromUserDto() {
  return new UserDtoModelSelector()
}

export const userDtoModelPrimitives = selectFromUserDto().email.phone.fullname.uuid.access_token.tempPassword.deleted.organizationId.verified.projectsCount.createdBy.defaultWorkspaceId.supportSessionUuid
